<template>
  <v-card class="main-content-card" flat>

    <v-toolbar flat>
      <v-toolbar-title>系统日志</v-toolbar-title>
      <span class="subheading ml-2">|</span>
    </v-toolbar>
    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                  label="用户"
                  v-model="form.userName"
                  :clearable="true"
                  hide-details
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                  label="地址"
                  v-model="form.uri"
                  :clearable="true"
                  hide-details
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>
    <v-data-table
        :headers="headers"
        :loading="loading"
        item-key="dbid"
        :pagination.sync="query"
        :items="pageResult.items"
        :total-items="pageResult.total"
        rows-per-page-text="每页记录数"
        no-data-text="没有数据。"
        no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1 }}
        </td>
        <td>{{ props.item.ts | timestamp}}</td>
        <td>{{props.item.method}} {{ props.item.uri }}</td>
        <td>{{ props.item.userName }}</td>
        <td>{{ props.item.roleName }}</td>
        <td>{{ props.item.deptName }}</td>
        <td>{{ props.item.parameters }}</td>
        <td>{{ props.item.body }}</td>
        <td>{{props.item.code}} {{ props.item.message }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

  </v-card>
</template>

<script>
// import {mapGetters} from 'vuex'

import mixin from '@/mixin'

const baseUri = '/api/syst/access-log';

export default {
  // 混入模块主页面（index）基本功能
  mixins: [mixin.index(baseUri)],

  components: {},

  data() {
    return {
      uri: baseUri,
      // 检索、分页、排序条件条件
      query: {
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        userName: '',
        uri: '',
        method: '',
        tsStart: '',
        tsEnd: ''
      },

      // 表头
      headers: [
        {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
        {text: '时间戳', align: 'left', sortable: true, value: 'ts', width: "200"},
        {text: '请求地址', align: 'left', sortable: true, value: 'rui', width: "200"},
        {text: '用户', align: 'left', sortable: true, value: 'userName', width: "80"},
        {text: '角色', align: 'left', sortable: true, value: 'roleName', width: "80"},
        {text: '部门', align: 'left', sortable: true, value: 'deptName', width: "120"},
        {text: '请求参数', align: 'left', sortable: true, value: 'parameters'},
        {text: '请求数据', align: 'left', sortable: true, value: 'body'},
        {text: '状态', align: 'left', sortable: true, value: 'code'},
        {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "40"}
      ],

      view: false,
      viewDbid: null
    }
  },

  computed: {
    // ...mapGetters(['funcIds'])
  },

  methods: {
    // 检索响应函数
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.doRoute(this.query);
    },
  }
}
</script>
